import { forwardRef, type SelectHTMLAttributes } from 'react';
import { cn } from './cn';

/** Select 높이 — Input 과 동일 계약(DESIGN-SPEC §10). 미지정 시 md(34px). */
export type SelectSize = 'sm' | 'md' | 'lg';

export interface SelectProps extends Omit<SelectHTMLAttributes<HTMLSelectElement>, 'size'> {
  size?: SelectSize;
}

const SIZE_HEIGHT: Record<SelectSize, string> = {
  sm: 'var(--control-h-sm)',
  md: 'var(--control-h-md)',
  lg: 'var(--control-h-lg)',
};

const SIZE_CLASS: Record<SelectSize, string> = {
  sm: 'px-2.5 text-[13px]',
  md: 'px-3 text-[13px]',
  lg: 'px-3.5 text-[14px]',
};

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, children, style, size = 'md', ...props }, ref) => (
    <select
      ref={ref}
      className={cn(
        'flex w-full rounded-md border transition-colors',
        SIZE_CLASS[size],
        'disabled:cursor-not-allowed disabled:opacity-50',
        'focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring-brand)]',
        className,
      )}
      style={{
        height: SIZE_HEIGHT[size],
        background: 'var(--surface-0)',
        color: 'var(--content-strong)',
        borderColor: 'var(--divider-strong)',
        ...style,
      }}
      {...props}
    >
      {children}
    </select>
  ),
);
Select.displayName = 'Select';
